import { UserCog } from 'lucide-react';
import { useState, type ReactElement } from 'react';

import { CardFrame } from '@/components/ui/card-frame';
import { usePermission } from '@/hooks/usePermission';
import type { DossierPerson } from '@/features/document-dossier/types';
import { useDocumentCompanyAccess } from '@/lib/document-company';
import type { DocumentStatus } from '@/lib/document-status';

import { OwnerModal } from './OwnerModal';

// Dueño de proceso en la ficha (G3-3, F1-29; reunión 27:39): todos lo ven; Calidad lo
// asigna, cambia o quita en cualquier estado salvo anulado. La mutación va a la empresa
// activa, así que en una ficha de otra empresa solo se muestra.

export interface OwnerEntry {
  id: string;
  companyId: string;
  code: string;
  status: DocumentStatus;
  owner: DossierPerson | null;
}

export function OwnerCard({ entry }: { entry: OwnerEntry }): ReactElement {
  const canRegister = usePermission('quality:document:register');
  const access = useDocumentCompanyAccess(entry.companyId);
  const [open, setOpen] = useState(false);
  const editable = canRegister && entry.status !== 'anulado' && access.kind === 'active';
  const name = entry.owner?.displayName ?? null;

  return (
    <CardFrame
      title="Dueño de proceso"
      className="d2"
      actions={
        editable ? (
          <button type="button" className="btn mut sm" onClick={() => setOpen(true)}>
            <UserCog size={14} aria-hidden="true" />
            {entry.owner === null ? 'Asignar dueño' : 'Cambiar dueño'}
          </button>
        ) : undefined
      }
    >
      <div className="cb">
        <p className="fld-note">
          {entry.owner === null ? 'Sin asignar' : <strong>{name ?? 'Persona sin nombre'}</strong>}
        </p>
        <p className="fld-hint">Recibe el aviso de la revisión periódica del documento.</p>
      </div>
      {open && (
        <OwnerModal
          entryId={entry.id}
          code={entry.code}
          hasOwner={entry.owner !== null}
          onClose={() => setOpen(false)}
        />
      )}
    </CardFrame>
  );
}
